const Enums = Object.freeze({
    questionType: Object.freeze({
        SingleChoice: 'RD',
        MultipleChoice: 'CH',
        TextBox: 'TX',
        TextArea: 'TA',
        TextBoxList: 'TL',
        Grid: 'TB',
        SmartGrid: 'SG',
        Priority: 'OD',
        Percent: 'PC',
        NumberRange: 'I',
        Ratings: 'RT',
        // CountryList: 'CO',
        StaticText: 'ST',
        DropdownList: 'SB',
        UrlVariable: 'UV',
        Form: 'FM',
        Date: 'DT',
        NumberForm: 'NF',
    }),
    // informs the level question is edited
    contextOidLevel: Object.freeze({
        QUESTION_EDITOR_CLIENT: 1,
        QLIST_CLIENT: 3,
        QLIST_DIVISION: 4,
        QLIST_PORTFOLIO: 5,
        QLIST_PRODUCT: 6,
        SURVEY_BUILDER: 7,
        CUSTOM_CATEGORY: 8,
    }),
    graph: Object.freeze({
        Area: 'area',
        Bar: 'bar',
        Column: 'column',
        Line: 'line',
    }),
    dateType: Object.freeze({
        D: 'D', // 1 date
        DR: 'DR', // 2 dates (date range)
    }),
    alignment: Object.freeze({
        V: 'vertical',
        H: 'horizontal',
    }),
    leftRight: {
        left: 0,
        right: 1,
    },
    skipLogicStatus: {
        noSkipLogic: 'NO',
        validSkipLogic: 'VALID',
        invalidSkipLogic: 'INVALID',
    },
})

export default Enums
